module.exports = __webpack_public_path__ + "static/media/rocket-fail.1799b8d9.svg";